import React, {
    useEffect, useState, useContext, useCallback
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './PolicyCommonDetails.metadata.json5';
import styles from './PolicyCommonDetails.module.scss';
import messages from './PolicyCommonDetails.messages';


function PolicyCommonDetails(props) {
    const { value: policyCommonDetails } = props;
    const { submissionVM: submissionVM } = props;
    const translator = useContext(TranslatorContext);

    const getPolHolderName = (polCommonDetails) => {
        const contacts1 = polCommonDetails.contacts;
        let insuredContact = {};
        if (contacts1 != null) {
            _.each(contacts1, (contact) => {
                if (contact.contactRole === 'Primary Named Insured') {
                    insuredContact = contact.contact;
                }
            });
        }
        return (
            <div>
                {insuredContact.displayName}
            </div>
        );
    };

    const getTotalTax =(submissionVM) => {
        const value =  submissionVM.quoteData.offeredQuotes.value.map(e => e.premium.taxes)
        return value[0];
    } 
    const getTotalFee =(submissionVM) => {
        const value =  submissionVM.quoteData.offeredQuotes.value.map(e => e.premium.fees_EY)
        return value[0];
    } 
    const getTotalBeforeTaxes =(submissionVM) => {
        const value =  submissionVM.quoteData.offeredQuotes.value.map(e => e.premium.totalBeforeTaxes)
        return value[0];
    } 
    const getTotal =(submissionVM) => {
        const value=  submissionVM.quoteData.offeredQuotes.value.map(e => e.premium.total)
        return value[0];
    }

    const getPolStatusName = (polCommonDetails) => {
        return polCommonDetails.periodStatus;
    };

    const getProducerCode = (polCommonDetails) => {
        let org = polCommonDetails.producerCodeOfRecordOrg;
         return  org.concat(" - ").concat(polCommonDetails.producerCode)
    }

    const overrides = {
        commonDetailsSection: {
            content: translator(messages.commonDetailsSection, {
                polNumber: policyCommonDetails.policyNumber
            })
        },
        producerCodeValue: {
            value: getProducerCode(policyCommonDetails)
        },
        policyStatusValue: {
            value: getPolStatusName(policyCommonDetails)
        },

        totalPremiumValue:{
            value: getTotalBeforeTaxes(submissionVM)
        },
        // taxesAndFeesValue:{
        //     value: getTotalTax(submissionVM)
        // },
        taxesValue: {
            value: getTotalTax(submissionVM)
        },
        feesValue : {
            value: getTotalFee(submissionVM)
        },
        totalCostValue:{
            value: getTotal(submissionVM)      
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrides}
            classNameMap={styles}
        />
    );
}

PolicyCommonDetails.propTypes = {
    value: PropTypes.shape({})
};

PolicyCommonDetails.defaultProps = {
    value: {}
};

export default PolicyCommonDetails;
